module.exports = __webpack_public_path__ + "img/jrys.b6cf11a8.png";